import { timelineEvents } from "@/mocks/home";

export default function TimelineStrip() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <span className="flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-git-commit-line"></i>
            </span>
            TIMELINE
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
            本周事件脉络
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            把主推合集的关键节点单独拎出来，按日期排好，先看脉络再看细节。
          </p>
        </div>
        <span className="whitespace-nowrap rounded-full bg-background-100 px-3.5 py-1.5 text-xs font-medium text-foreground-700 ring-1 ring-background-200">
          09-06 至 09-10
        </span>
      </div>

      <div className="scrollbar-none mt-8 flex gap-4 overflow-x-auto pb-2 md:grid md:grid-cols-5 md:overflow-visible">
        {timelineEvents.map((event, index) => (
          <div
            key={event.date}
            className="relative min-w-[240px] shrink-0 rounded-lg border border-background-200/80 bg-background-50 p-5 md:min-w-0"
          >
            <span className="absolute -top-px left-5 h-0.5 w-10 bg-accent-500"></span>
            <div className="flex items-center justify-between">
              <span className="font-heading text-sm font-bold text-foreground-950">
                {event.date}
              </span>
              <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-800">
                {event.tag}
              </span>
            </div>
            <h3 className="mt-3 font-heading text-sm font-bold leading-snug text-foreground-950">
              {event.title}
            </h3>
            <p className="mt-2 text-xs leading-relaxed text-foreground-600">
              {event.desc}
            </p>
            <span className="mt-4 block text-[11px] tracking-widest text-foreground-400">
              STEP {String(index + 1).padStart(2, "0")}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}